import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/store/auth.store';
import { traerPermiso } from '@/api/copiloto-historial.api';

/**
 * ¿Quien está mirando puede ver el historial completo del copiloto?
 *
 * Lo contesta la API, porque el rol del panel no alcanza: también lo ve quien
 * tenga el teléfono de un dueño del directorio del asistente. El OWNER no espera
 * la respuesta —la API siempre lo deja— para que su menú no parpadee.
 *
 * Mientras llega la respuesta, `puedeVer` es `false`: la entrada del menú
 * aparece un instante tarde en vez de aparecer y desaparecer.
 */
export function usePermisoHistorial(): { puedeVer: boolean; cargando: boolean } {
  const userId = useAuthStore((s) => s.user?.id);
  const role = useAuthStore((s) => s.user?.role);
  const esOwner = role === 'OWNER';

  const permiso = useQuery({
    // Por usuario: si cambia la sesión, la respuesta vieja no sirve.
    queryKey: ['copiloto', 'historial', 'permiso', userId ?? 'sin-sesion'],
    queryFn: traerPermiso,
    enabled: Boolean(userId) && !esOwner,
    staleTime: 5 * 60_000,
  });

  return {
    puedeVer: esOwner || permiso.data?.puedeVer === true,
    cargando: !esOwner && (!userId || permiso.isLoading),
  };
}
